import { DownloadButton } from '@/features/invoices/components/Details/Components/Left/DownloadButton';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './PdfHeader.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  isEmpty?: boolean;
  onDownloadClick?: () => void;
  fileName?: string;
  invoiceId?: string;
};

export const PdfHeader: FC<Props> = memo(
  ({ isEmpty, onDownloadClick, fileName, invoiceId }) => {
    return (
      <div
        className={cx(styles.container, {
          [styles['non-attachment']]: isEmpty,
        })}
      >
        {onDownloadClick && (
          <DownloadButton
            onDownloadClick={onDownloadClick}
            fileName={fileName}
            invoiceId={invoiceId}
          />
        )}
      </div>
    );
  }
);
PdfHeader.displayName = 'PdfHeader';
